import { render, staticRenderFns } from "./DocumentSalesProfit.vue?vue&type=template&id=2f285b0c"
import script from "./DocumentSalesProfit.vue?vue&type=script&lang=js"
export * from "./DocumentSalesProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports